import React from "react";
import { Box, Typography } from "@mui/material";

import logoImage from "../../../images/logo.png";

export default function AuthFormHeader({
  title,
  subtitle,
  logoMb = 4,
  mb = 4,
}) {
  return (
    <>
      <Box
        component="img"
        src={logoImage}
        alt="EFabric"
        sx={{
          height: 40,
          mb: logoMb,
          objectFit: "contain",
          userSelect: "none",
        }}
      />

      <Typography sx={{ fontSize: "2rem", fontWeight: 700, color: "#0f172a" }}>
        {title}
      </Typography>
      <Typography
        sx={{ fontSize: "1.05rem", color: "text.secondary", mt: 1, mb }}
      >
        {subtitle}
      </Typography>
    </>
  );
}
